import React from 'react';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';

import './jobform.css';

import Layout from 'components/global/Layout/Layout';
import JobForm from 'components/jobform/JobForm/JobForm';

class JobFormPage extends React.Component {
  render() {
    const { location } = this.props;

    const searches = location.search.split('&');
    const jobKey = searches[0].split('=')[1];

    return (
      <Layout>
        <div className='JobFormPage-root'>
          <JobForm jobKey={jobKey} />
        </div>
      </Layout>
    );
  }
}

const connectedJobFormPage = connect()(JobFormPage);

const wrappedJobFormPage = firebaseConnect()(connectedJobFormPage);

export default wrappedJobFormPage;



// WEBPACK FOOTER //
// ./src/routes/jobform/jobform.js